// extracted by mini-css-extract-plugin
export default {"searchList":"src-components-InputBreakTag-Tag__searchList--ljQtw","addIcon":"src-components-InputBreakTag-Tag__addIcon--W0MuC","tag":"src-components-InputBreakTag-Tag__tag--VlWr8"};